module.exports = __webpack_public_path__ + "img/stock7.4a526c73.png";